import { Box, Button, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 12px;
  overflow: hidden;
  gap: 8px;
`

export const Names = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
`

export const GroupName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'unavailable',
})<{ unavailable?: boolean }>`
  width: 100%;
  flex-shrink: 1;
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.01em;
  text-align: left;
  color: ${({ theme, unavailable }) =>
    unavailable ? '#EA4968' : theme.palette.primary.main};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const CategoryName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'unavailable',
})<{ unavailable?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme, unavailable }) =>
    unavailable ? '#EA4968' : theme.palette.custom.gray2};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const ToggleButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  text-transform: none;
  margin-right: 4px;
  padding-left: 4px;
  padding-right: 4px;

  & .MuiButton-startIcon {
    margin-left: 0;
    margin-right: 0;
  }
`

export const IconWrapper = styled(Box)`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Items = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.custom.gray2};
  flex-shrink: 0;
`
